import { render, staticRenderFns } from "./allLeadList.vue?vue&type=template&id=c93d8b00&"
import script from "./allLeadList.vue?vue&type=script&lang=js&"
export * from "./allLeadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports